function Settings(){
    return(
        <div className="w-full h-full flex flex-col justify-center items-center bg-custom-gradient animate-gradient">Settings</div>
    )
}

export default Settings;